import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@pinpoint/design-kit';
import DefaultTheme from 'src/styles/DefaultTheme';

const StyledButton = styled(Button)`
  :active {
    background-color: ${({ disabled }) => (!disabled ? DefaultTheme.colors.blue : '')};
  }
`;

function TabButton({ selected, children, ...userProps }) {
  return (
    <StyledButton
      bg={selected ? 'blueLight' : 'blue'}
      hoverBg={selected ? '' : 'blueLight'}
      m={{ r: '0.5rem' }}
      p={{ x: '0.75rem' }}
      h="1.875rem"
      cursor={selected ? 'initial' : 'pointer'}
      {...userProps}
    >
      {children}
    </StyledButton>
  );
}

TabButton.defaultProps = {
  selected: null,
  children: null,
};

TabButton.propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default TabButton;
